module.exports = ".width-100 {\n  width: 100%;\n}\n\n.flexbox-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n}\n\n/* */\n\n::ng-deep  .mat-select-arrow {\n  border-color: white !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/collana/collana-combo-selector/collana-combo-selector.component.css
// module id = ./src/app/components/collana/collana-combo-selector/collana-combo-selector.component.css
// module chunks = main